import styled from "styled-components";
import { Select, Avatar } from "antd";

export const UserSelect = styled(Select)`
`;


export const UserSelectOption = styled(Select.Option)`
  border-bottom: 1px solid #e8e8e8;
`;

export const UserSelectContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Circle = styled.div<{ $backgroundPhoto?: string | null }>`
	color: #fff;
	padding: 13px;
	width: 40px;
	height: 40px;
	background: ${(props) =>
		props.$backgroundPhoto === (null || undefined)
			? "#6d767e"
			: `url(${props.$backgroundPhoto}) no-repeat center center/cover`};
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
`;
